import React, { Component } from 'react'
import PropTypes from 'prop-types';

let propTypes = {
    isShow: PropTypes.func.isRequired
}

export default class Modal extends Component {
    componentWillMount() {
        this.props.isShow(true)
    }

    clickClose = () => {
        this.props.isShow(false)
    }

    render() {
        return (
            <div className="modal-container" id="sendTestimoni">
                <div className="modal-dialog animated faster fadeIn" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Berhasil</h4>
                            <button type="button" className="close" aria-label="Close" onClick={this.clickClose}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p>Terima kasih pesan anda berhasil terkirim.&hellip;</p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default" onClick={this.clickClose}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

Modal.propTypes = propTypes;